import React, { useRef, useState } from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import { FiSearch } from 'react-icons/fi';
import faqImg from './faq.png';

// import { Container } from './styles';

const randomId = () =>
  Math.random().toString(36).substring(2, 32).toUpperCase();

const items = [
  {
    id: randomId(),
    heading: 'Como cadastrar uma fazenda',
    img: 'https://digitalfarms.com.br/wp-content/uploads/2020/11/S03.png',
    content: (
      <div>
        <p>
          <h6>
            <br />
            <strong>WEB </strong>
            <br />
          </h6>{' '}
          Na tela inicial, após o login serão exibidas todas as fazendas
          cadastradas em seu perfil de acesso. Para criar uma nova afazenda
          acesse a opção criar nova Fazenda no botão localizado na lateral
          direita <strong>&quot;Nova fazenda&quot;</strong>. Será necessário
          informar todos os dados pertinentes ao cadastro da Fazenda e efetuar o
          vínculo com o Produtor (É necessário que o produtor já esteja
          previamente cadastrado, em caso de dúvida acesse o menu{' '}
          <strong>&quot;Como cadastrar um Produtor&quot;</strong>). Após a
          conclusão do cadastro será enviado um e-mail contendo a senha de
          acesso.
          <br />
          <br />
          <strong>APP </strong>
          <br />
          Na tela inicial, após o login serão exibidas todas as fazendas
          cadastradas em seu perfil de acesso. Para criar uma nova fazenda
          acesse a opção criar nova Fazenda no botão inferior{' '}
          <strong>&quot;Criar nova fazenda&quot;</strong>. Será necessário
          informar todos os dados pertinentes ao cadastro da Fazenda e efetuar o
          vínculo com o Produtor (É necessário que o produtor já esteja
          previamente cadastrado, em caso de dúvida acesse o menu{' '}
          <strong>&quot;Como cadastrar um Produtor&quot;</strong>). Após a
          conclusão do cadastro será enviado um e-mail contendo a senha de
          acesso.
        </p>
      </div>
    ),
  },
  {
    id: randomId(),
    heading: 'Como cadastrar um produtor',
    img: 'https://digitalfarms.com.br/wp-content/uploads/2020/11/S03.png',
    content: (
      <div>
        <p>
          <h6>
            <br />
            <strong>WEB </strong>
            <br />
          </h6>{' '}
          Na tela inicial acesse no menu ao lado direito a opção{' '}
          <strong>&quot;Produtores&quot;</strong>, selecione a seguir a opção{' '}
          <strong>&quot;Novo produtor&quot;</strong>. Será necessário informar
          todos os dados pertinentes ao Produtor e finalizar o cadastro no botão{' '}
          <strong>&quot;Salvar&quot;</strong>). Após a conclusão do cadastro
          será enviado um e-mail contendo a senha de acesso. <br />
          <br />
          <h6>
            <br />
            <strong>APP </strong>
            <br />
          </h6>{' '}
          Na tela inicial após o login acesse o ícone de perfil localizado no
          canto direito superior do seu APP Digital Farms e selecione{' '}
          <strong>&quot;Novo produtor&quot;</strong>. Será necessário informar
          todos os dados pertinentes ao Produtor e finalizar o cadastro no botão{' '}
          <strong>&quot;Salvar&quot;</strong>). Após a conclusão do cadastro
          será enviado um e-mail contendo a senha de acesso.
          <br />
          <br />
        </p>
      </div>
    ),
  },
  {
    id: randomId(),
    heading: 'Como cadastrar um Consultor',
    img: 'https://digitalfarms.com.br/wp-content/uploads/2020/11/S03.png',
    content: (
      <div>
        <p>
          <h6>
            <br />
            <strong>WEB </strong>
            <br />
          </h6>{' '}
          Na tela inicial acesse no menu ao lado direito a opção{' '}
          <strong>&quot;Consultores&quot;</strong>, selecione a seguir a opção{' '}
          <strong>&quot;Novo consultor&quot;</strong>. Será necessário informar
          todos os dados pertinentes ao Consultor, vincular a(s) fazenda(s) ao
          qual o consultor será responsável e finalizar o cadastro no botão{' '}
          <strong>&quot;Salvar&quot;</strong>. Após a conclusão do cadastro será
          enviado um e-mail contendo a senha de acesso.
          <br />
          <br />
        </p>
      </div>
    ),
  },
  {
    id: randomId(),
    heading: 'Como cadastrar um Operacional',
    img: 'https://digitalfarms.com.br/wp-content/uploads/2020/11/S03.png',
    content: (
      <div>
        <p>
          <h6>
            <br />
            <strong>WEB </strong>
            <br />
          </h6>{' '}
          Na tela inicial acesse no menu ao lado direito a opção{' '}
          <strong>&quot;Operacional&quot;</strong>, selecione a seguir a opção{' '}
          <strong>&quot;Novo operacional&quot;</strong>. Será necessário
          informar todos os dados pertinentes ao Operacional, vincular a(s)
          fazenda(s) ao qual o Operacional será vinculado e finalizar o cadastro
          no botão <strong>&quot;Salvar&quot;</strong>. Após a conclusão do
          cadastro será enviado um e-mail contendo a senha de acesso. <br />
          <br />
        </p>
      </div>
    ),
  },
  {
    id: randomId(),
    heading: 'Como cadastrar um usuário Administrador',
    img: 'https://digitalfarms.com.br/wp-content/uploads/2020/11/S03.png',
    content: (
      <div>
        <p>
          <h6>
            <br />
            <strong>WEB </strong>
            <br />
          </h6>{' '}
          Na tela inicial acesse no menu ao lado direito a opção{' '}
          <strong>&quot;Usuários Admin&quot;</strong>, selecione a seguir a
          opção <strong>&quot;Novo usuário&quot;</strong>. Será necessário
          informar todos os dados pertinentes ao novo usuário e finalizar o
          cadastro no botão <strong>&quot;Salvar&quot;</strong>. Após a
          conclusão do cadastro será enviado um e-mail contendo a senha de
          acesso. <br />
          <br />
        </p>
      </div>
    ),
  },
  {
    id: randomId(),
    heading: 'Como utilizar o canal de chat com o suporte',
    img: 'https://digitalfarms.com.br/wp-content/uploads/2020/11/S03.png',
    content: (
      <div style={{ maxHeight: 300, overflowY: 'auto', overflowX: 'hidden' }}>
        <p>
          <h6>
            <br />
            <strong>WEB </strong>
            <br />
          </h6>{' '}
          O Chat WEB será utilizado exclusivamente pela equipe de administração
          Digital Farms. <br />
          <br />
          Na tela inicial acesse no menu ao lado direito a opção{' '}
          <strong>&quot;Chat&quot;</strong>, as mensagens dos
          parceiros/produtores/operacional serão exibidas na aba{' '}
          <strong>&quot;Em aberto&quot;</strong>. Ao lado do registro da
          mensagem será possível iniciar a conversa acessando o botão{' '}
          <strong>&quot;Aceitar&quot;</strong>, Neste momento será registrado
          esse chamado em nome do usuário Administrador que aceitou o
          atendimento, transferindo o registro para a aba{' '}
          <strong>&quot;Aceitar&quot;</strong>.<br /> <br /> Sempre que ocorrer
          uma nova solicitação de suporte via chat, será apresentada o ícone{' '}
          <strong>&quot;Sininho&quot;</strong>, informando que um novo pedido de
          suporte está aguardando atendimento. <br />
          <br />
          <h6>
            <br />
            <strong>APP </strong>
            <br />
          </h6>{' '}
          O Chat APP será utilizado exclusivamente pelos parceiros da Digital
          Farms Digital Farms. <br />
          <br />
          Na tela inicial após o login acesse o ícone de perfil localizado no
          canto direito superior do seu APP Digital Farms e selecione{' '}
          <strong>&quot;Suporte&quot;</strong>.
          <br />
          <br />
        </p>
      </div>
    ),
  },
];

function Faq() {
  const [filtro, setFiltro] = useState('');
  const [active, setActive] = useState(null);
  const filtroRef = useRef();

  const handleChange = (e) => {
    clearTimeout(filtroRef.current);
    filtroRef.current = setTimeout(() => {
      setFiltro(e.target.value);
    }, 300);
  };

  return (
    <>
      <Row>
        <Col>
          <h4 className="mb-3">Faq</h4>
        </Col>
      </Row>
      <Card>
        <CardBody>
          <Row>
            <Col lg={5}>
              <img
                src={active?.img || faqImg}
                alt="FAQ"
                width="100%"
                style={{
                  objectFit: 'contain',
                }}
              />
            </Col>
            <Col lg={7}>
              <div className="py-3 position-relative">
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    left: 15,
                  }}
                >
                  <FiSearch />
                </div>
                <input
                  className="form-control"
                  style={{
                    paddingLeft: 40,
                  }}
                  onChange={handleChange}
                  placeholder="Digite para pesquisar"
                />
              </div>
              <Accordion
                allowZeroExpanded
                onChange={([e]) => {
                  setActive(items.find((f) => f.id === e));
                }}
              >
                {items.map((item) => (
                  <React.Fragment key={item.id}>
                    {item.label && <h4 className="mt-3">{item.label}</h4>}
                    <AccordionItem uuid={item.id}>
                      <AccordionItemHeading
                        className={`${
                          active?.id === item.id
                            ? 'accordion__heading active'
                            : 'accordion__heading'
                        }`}
                      >
                        <AccordionItemButton>
                          {item.heading}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      <AccordionItemPanel>{item.content}</AccordionItemPanel>
                    </AccordionItem>
                  </React.Fragment>
                ))}
              </Accordion>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
}

export default Faq;
